import { isNil, uniq } from 'lodash-es';

export const validateConnectorIds = (connectorIds?: number[]) => {
  if (isNil(connectorIds)) {
    throw new Error('Connector IDs cannot be empty');
  }

  connectorIds.forEach((connectorId) => validateConnectorId(connectorId));

  const hasNoDuplicates = uniq(connectorIds).length === connectorIds.length;
  if (!hasNoDuplicates) {
    throw new Error('Connector ID cannot have same value');
  }
};

export const validateConnectorId = (connectorId?: number) => {
  if (isNil(connectorId)) {
    throw new Error('Connector ID cannot be empty');
  }
  if (connectorId <= 0) {
    throw new Error('Connector ID cannot be 0 or negative');
  }
};
